import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD,
} from '@packages/systems/commerce/constants';
import withAttribute from './withAttribute';

import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const ZipPostalCodeInput = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <input
        {...generateAttributes(attributes, classes)}
        name="address_zip"
        type="text"
        required
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'billingAddressPostalCode',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Zip/Postal Code',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD
  )(ZipPostalCodeInput),
  style: {
    base: {
      main: checkoutInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
  fields: {},
});

export default config;
